import { useAuth0 } from "@auth0/auth0-react";
import { TableContainer } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Pagination from "@material-ui/lab/Pagination";
import { ReactComponent as PlusIcon } from "assets/icons/plus.svg";
import MyModal from "components/MyModal";
import TableColumnFilter from "components/TableColumnFilter/TableColumnFilter";
import PastoralService from 'Lib/API/PastoralApi';
import { debounce } from "lodash";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { toastr } from "react-redux-toastr";
import CreateTrigger from "./createTrigger";

import Button from "components/button/Button";
import AlertDialog from "components/Dialog";
import "./index.scss";
import { activeOptions, recurringOptions } from "./taskAutomation";
import TaskAutomationTableBody from "./TaskAutomationTableBody";
import { fontConfig } from "theme/fontConfig";
const TableCellHead = withStyles((theme) => ({
  root: {
    height: "39px",
    padding: "0px 20px",
    borderBottom: "none",
    fontFamily: fontConfig.GeneralTableCellHeadFont.family,
  },
}))(TableCell);


function TaskAutomation({
  eventTypes,
  getEventTypesLoading,
}) {
  const { getAccessTokenSilently } = useAuth0();

  const [loading, setLoading] = useState(false);
  const [eventUserLoading, setEventUserLoading] = useState(false);
  const [usersData, setUsersData] = useState([]);
  const [page, setPage] = useState(1);
  const [tasksAutomation, setTasksAutomation] = useState([]);
  const [tasksAutomationTotal, setTasksAutomationTotal] = useState(0);
  const [selectedTask, setSelectedTask] = useState(null);
  const [openConfirmDialog, setConfirmDialog] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
    const [confirmClose, setConfirmClose] = useState(false);
  
  const [selectedFilter, setSelectedFilter] = useState({
    eventType: [],
    recurring: [],
    clergyType: [],
    active: [],
  })
  const [selectedFilterAll, setSelectedFilterAll] = useState({
    eventType: false,
    recurring: false,
    clergyType: false,
    active: false,
  })

  const [openCreateTriggerModal, setOpenCreateTriggerModal] = useState(false);



  const getUsersHandler = async () => {
    setEventUserLoading(true);
    const token = await getAccessTokenSilently();
    PastoralService.getEventUsers({ token, page: 1 })
      .then((res) => {
        if (res) {
          const formattedUsers = res?.users.map((item) => ({ 
            label: `${item?.type} ${item?.fullName ? "- " + item?.fullName : ""}`,
            value: item?.id 
          }));
          setUsersData(formattedUsers);
        }
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setEventUserLoading(false);
      });
  };
  const getTaskAutomationHandler = async (initialPage) => {
    const currentPage = initialPage || page;
    if(currentPage === 1) {
      setPage(1);
    }
    setLoading(true);

    const payload = {
      filter: { 
        eventType: (selectedFilter?.eventType?.length > 0  && !selectedFilterAll?.eventType) ? selectedFilter?.eventType : undefined,
        recurring: (selectedFilter?.recurring?.length > 0 && !selectedFilterAll?.recurring) ? selectedFilter?.recurring : undefined,
        clergyType: (selectedFilter?.clergyType?.length > 0 && !selectedFilterAll?.clergyType) ? selectedFilter?.clergyType : undefined,
        active1: (selectedFilter?.active?.length > 0 && !selectedFilterAll?.active) ? selectedFilter?.active : undefined,
      }
    }
    const token = await getAccessTokenSilently();
    PastoralService.getTasksAutomation({ token, page: currentPage, limit: 30,payload })
      .then((res) => {
        if (res) {
          setTasksAutomation(res?.triggers);
          setTasksAutomationTotal(res?.total);
        }
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setLoading(false);
      });
  }
  

  useEffect(() => {
    getUsersHandler();
  }, []);

  useEffect(() => {
    const selectedFilterValues = Object.values(selectedFilter);
    const isFilterSelected = selectedFilterValues.some((item) => item.length > 0);
    if(isFilterSelected) {
      debounceCall();
    } else {
      getTaskAutomationHandler(1);
    }
    return () => debounceCall.cancel();
  }, [selectedFilter]);


  const onEventTypeFilterChange = (name, value) => {
    if(value === "all") {
      setSelectedFilter({
        ...selectedFilter,
        [name]: selectedFilterAll?.[name] ? [] : eventTypes.map(item => item.value),
      });
      setSelectedFilterAll({
        ...selectedFilterAll,
        [name]: !selectedFilterAll?.[name],
      });
      return;
    }
    setSelectedFilterAll({
      ...selectedFilterAll,
      [name]: false,
    });
    if (selectedFilter?.[name]?.includes(value)) {
      setSelectedFilter({
        ...selectedFilter,
        [name]: selectedFilter?.[name]?.filter((item) => item !== value),
      });
    } else {
      setSelectedFilter({
        ...selectedFilter,
        [name]: [...selectedFilter?.[name], value],
      });
    }
  }

  const debounceCall = useCallback(
    debounce(() => {
      if (selectedFilter) {
        getTaskAutomationHandler(1);
      }
    }, 500),
    [selectedFilter, selectedFilterAll]
  );




  const openCreateTrigger = (row) => {
    setSelectedTask(row ? row : null);
    setOpenCreateTriggerModal(true);
  }

  const closeCreateTrigger = () => {
    setSelectedTask(null);
    setOpenCreateTriggerModal(false);
  }

  
  const eventTypesOptions = useMemo(() => {
    return [
      {
        label: "All",
        value: "all",
      },
      ...eventTypes
    ]
  },[eventTypes]);

  const usersDataOptions = useMemo(() => {
    return [
      {
        label: "All",
        value: "all",
      },
      ...usersData
    ]
  },[usersData]);



  const closeDeleteDialog = () => {
    setSelectedTask(null);
    setConfirmDialog(false);
  }
  const openDeleteDialog = (row) => {
    setSelectedTask(row);
    setConfirmDialog(true);
  }
  const deleteHandler = async () => {
    const token = await getAccessTokenSilently();
    setDeleteLoading(true);
    PastoralService.deleteTaskAutomation({ id: selectedTask?.id, token })
      .then((res) => {
        toastr.success("Success", "Task Automation Deleted Successfully");
        getTaskAutomationHandler();
        closeDeleteDialog();
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setDeleteLoading(false);
      });

  } 

  const closeModal = () => {
    setConfirmClose(true);
  }
  const confirmCloseHandler = () => {
    setConfirmClose(false);
    closeCreateTrigger();
  }

  return (
    <div>
      <div className="schedule-reports-setting-page pastoral-task-automation">
        <div className="table-header mb-5">
          <div className="d-flex table-header-buttons schedule-btn-report-add">
          <Button
              variant="primary"
              onClick={() => openCreateTrigger()}
              style={{ marginLeft: 10 }}
              size="md"
          >
              <PlusIcon />
              <span>New Task Automation</span>
          </Button>
          </div>
        </div>
      </div>

      <div className="schedule-table-container">
        <TableContainer className="scroll-table">
          <Table
            class="main-tables"
            aria-label="collapsible table"
            sx={{ minWidth: 750 }}
          >
            <TableHead className="charges-table sticky-table-header">
              <TableRow>
                <TableCellHead
                  component="th"
                  scope="row"
                  padding="none"
                  className="status-heads"
                  align="left"
                  key="event"
                >
                  <div className="d-flex h-100 justify-content-start align-items-center" style={{ gap: "10px" }}>
                    EVENT TYPE
                    <TableColumnFilter
                      options={eventTypesOptions}
                      onChange={(value) => onEventTypeFilterChange("eventType", value)}
                      value={selectedFilter?.eventType}
                      allSelected={selectedFilterAll?.eventType}
                    />
                  </div>
                </TableCellHead>

                <TableCellHead className="status-head2" align="left">
                  GET IN TOUCH
                </TableCellHead>
                <TableCellHead className="account-names" align="left">
                  <div className="d-flex h-100 justify-content-start align-items-center" style={{ gap: "10px" }}>
                    RECURRING
                    <TableColumnFilter
                      options={recurringOptions}
                      onChange={(value) => onEventTypeFilterChange("recurring", value)}
                      value={selectedFilter?.recurring}
                      allSelected={selectedFilterAll?.recurring}
                    />
                  </div>
                </TableCellHead>
                <TableCellHead align="left" className="paid-heads">
                  ACTION TYPE
                </TableCellHead>
                <TableCellHead
                  className="ledger-heads"
                  align="left"
                >
                  <div className="d-flex h-100 justify-content-start align-items-center" style={{ gap: "10px" }}>
                    ASSIGN TO
                    <TableColumnFilter
                      options={usersDataOptions}
                      onChange={(value) => onEventTypeFilterChange("clergyType", value)}
                      value={selectedFilter?.clergyType}
                      allSelected={selectedFilterAll?.clergyType}
                    />
                  </div>
                </TableCellHead>
                <TableCellHead
                  align="left"
                  className="transaction-heads"
                >
                  <div className="d-flex h-100 justify-content-start align-items-center" style={{ gap: "10px" }}>
                    ACTIVE
                    <TableColumnFilter
                      options={activeOptions}
                      onChange={(value) => onEventTypeFilterChange("active", value)}
                      value={selectedFilter?.active}
                      allSelected={selectedFilterAll?.active}
                    />
                  </div>
                </TableCellHead>

                <TableCellHead className="empty-heads sticky-header-column" align="left" />
              </TableRow>
            </TableHead>

            <TaskAutomationTableBody 
              tasksList={tasksAutomation}
              loading={loading}
              onDeleteTask={openDeleteDialog}
              openCreateTrigger={openCreateTrigger}
            />
          </Table>
        </TableContainer>

        <div className="pagination-custom mt-5 pagination-scdeuled">
          <Pagination
            count={Math.ceil(tasksAutomationTotal / 30)}
            color="primary"
            variant="outlined"
            page={page}
            onChange={(e, value) => {
              setPage(value);
              getTaskAutomationHandler(value);
            }}
          />
        </div>
      </div>

      <MyModal
					className="add-task-automation-modal"
					open={openCreateTriggerModal}
					onClose={closeModal}
				>
					<CreateTrigger 
            closeModal={closeModal} 
            handleClose={closeCreateTrigger}
            eventsTypes={eventTypes} 
            usersData={usersData} 
            taskData={selectedTask}
            type={selectedTask ? "edit" : "create"}
            fetchTasks={getTaskAutomationHandler}
            getEventTypesLoading={getEventTypesLoading}
          />
				</MyModal>
        <AlertDialog
          open={openConfirmDialog}
          onDecline={closeDeleteDialog}
          onAccept={() => {
            if (selectedTask?.id) {
              deleteHandler();
            }
          }}
          title={"Are you sure?"}
          description={"Do you want to delete this automation?"}
          disabled={deleteLoading}
        />
        <AlertDialog
          open={confirmClose}
          onDecline={() => {
            setConfirmClose(false);
          }}
          onAccept={confirmCloseHandler}
          title={"Are you sure?"}
          description={"Do you want to discard the changes you made?"}
        />
    </div>
  );
}


export default TaskAutomation;

